import { render, staticRenderFns } from "./download-poster-dialog.vue?vue&type=template&id=20d132d6&scoped=true&"
import script from "./download-poster-dialog.vue?vue&type=script&lang=js&"
export * from "./download-poster-dialog.vue?vue&type=script&lang=js&"
import style0 from "./download-poster-dialog.vue?vue&type=style&index=0&id=20d132d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d132d6",
  null
  
)

export default component.exports